import React from "react";
import { FaExclamationTriangle} from "react-icons/fa";

export default function ErrorPage() {
  return (
    <div
      style={{
        maxWidth: "650px",
        margin: "40px auto",
        borderRadius: "10px",
        boxShadow: "0 5px 20px rgba(0,0,0,0.15)",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#fff",
        padding: "40px 20px",
        textAlign: "center",
      }}
    >
      <FaExclamationTriangle style={{ color: "#f1cf53ff", fontSize: "40px", marginBottom: "20px" }} />
      <i>
      <p style={{ color: "#333", marginBottom: "10px" }}>
        Oops! Looks like the page doesn't exist
      </p>
      <p style={{ color: "#333", marginBottom: "10px" }}>
        Please try checking the URL again
      </p>
      </i>
    </div>
  );
}